module.exports = __webpack_public_path__ + "static/media/videofx_vc-plus-300x300.c72d57a1.jpg";